import React, { useState } from 'react';
import './portfolio.css';
import { useCopyToClipboard } from 'react-use';
import { FaCopy } from 'react-icons/fa'
import { toast } from 'react-hot-toast';
import { portfolio_data } from '../../data/portfolio_data';
export const Portfolio = () => {
    const [open, setOpen] = useState('');
    const [state, copyToClipboard] = useCopyToClipboard();


    // let texts = "Copy this";
    const handleClick = (idx) => {
        setOpen(open === idx ? '' : idx);


    };

    return (
        <div id="portfolio" className="container pb-5">
            <div>

            </div>
            <div className="row">
                <h1 className="mt-4 mb-4 text-center">
                    <span>P</span>rojects
                </h1>

                {portfolio_data.map((val, idx) => (
                    <div
                        className="col-lg-4 col-md-6 mb-5 d-flex justify-content-center align-items-center"
                        key={idx}
                    >
                        <div className=" portfolio__card">
                            <div className='img__box'>
                                <img
                                    loading="lazy"
                                    src={val.img}
                                    className="card-img-top portfolio__img"
                                    alt="img"
                                />
                            </div>
                            <div className="card-body">
                                <h5 className="card-title">{val.title}</h5>
                                <div className="portfolio__btns">

                                    <button
                                        className="githup__btn"
                                        onClick={() => handleClick(idx)}
                                    >
                                        Github
                                    </button>
                                    <a
                                        href={val.websiteUrl}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="website__btn"
                                    >
                                        Website
                                    </a>
                                </div>
                                {open === idx && (
                                    <div className="click_btn">
                                        <a
                                            className="frontend_btn"
                                            href={val.githubUrl[0].frontend}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        >
                                            Frontend
                                        </a>
                                        <a
                                            className="backend_btn"
                                            href={val.githubUrl[1].backend}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        >
                                            Backend
                                        </a>
                                    </div>
                                )}
                                <div>
                                    {val.optionTitle && (
                                        <div className="select" defaultValue={"Credentials"}>
                                            {"Credentials"}

                                            <div className="select__dropdown">

                                                <div className="select__option">{val.optionTitle}</div>
                                                {val.optionPath && <div className="select__option">{val.optionPath}</div>}
                                                <div className="select__option" >
                                                    Email:  {val.adminEmail}
                                                    <span className="copybtn" onClick={() => {
                                                        copyToClipboard(val.adminEmail)
                                                        toast(`Copy ${val.adminEmail}`, {
                                                            icon: `💚 `,
                                                            style: {
                                                                height: "50px",

                                                            },
                                                        });
                                                    }}>
                                                        <FaCopy />
                                                    </span>
                                                </div>
                                                <div className="select__option">
                                                    Password:  {val.adminPassword}
                                                    <span className="copybtn"


                                                        onClick={() => {
                                                            copyToClipboard(val.adminPassword)
                                                            toast(`Copy ${val.adminPassword}`, {
                                                                icon: `💚 `,
                                                                style: {
                                                                    height: "50px",
                                                                    // borderRadius: '10px',
                                                                    // background: 'red',
                                                                    // color: '#fff',
                                                                },
                                                            });
                                                        }}>
                                                        <FaCopy />
                                                    </span>
                                                </div>

                                                {val.optionTitle2 &&
                                                    <>
                                                        <div className="select__option">
                                                            {val.optionTitle2}</div>
                                                        <div className="select__option" >
                                                            Email:  {val.userEmail}
                                                            <span className="copybtn" onClick={() => {
                                                                copyToClipboard(val.userEmail)
                                                                toast(`Copy ${val.userEmail}`, {
                                                                    icon: `💚 `,
                                                                    style: {
                                                                        height: "50px",

                                                                    },
                                                                });
                                                            }}>
                                                                <FaCopy />
                                                            </span>
                                                        </div>
                                                        <div className="select__option">
                                                            Password:  {val.userPassword}
                                                            <span className="copybtn"


                                                                onClick={() => {
                                                                    copyToClipboard(val.userPassword)
                                                                    toast(`Copy ${val.userPassword}`, {
                                                                        icon: `💚 `,
                                                                        style: {
                                                                            height: "50px",

                                                                        },
                                                                    });
                                                                }}>
                                                                <FaCopy />
                                                            </span>
                                                        </div>
                                                    </>}
                                                {val.optionCode && <div className="select__option">

                                                    <span className="copybtn" onClick={() => {
                                                        copyToClipboard(val.optionCode)
                                                        toast(`Copy ${val.optionCode}`, {
                                                            icon: `💚 `,
                                                            style: {
                                                                height: "50px",

                                                            },

                                                        });
                                                    }}>
                                                        <FaCopy title='Copy' />
                                                    </span>
                                                    {val.optionCode}</div>}

                                            </div>

                                        </div>
                                    )}</div>


                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};


